import React from 'react';

import Grid from '../../Grid';
import { Typography } from '../../Typography';

interface Props {
  title: string;
}

const Layout: React.FC<Props> = ({ title, children }) => (
  <Grid container spacing={5} style={{ width: '99vw', padding: '15px' }}>
    <Grid item xs={12}>
      <Typography.H1>{title}</Typography.H1>
    </Grid>
    <Grid item xs={12}>
      <Grid container direction="column" alignContent="center" spacing={2}>
        {children}
      </Grid>
    </Grid>
  </Grid>
);

export default Layout;
